import { GoogleRMKT, GoogleSiteTag } from "@/pixels/providers/google";
import * as ERRORES from "@/config/constants/step-constants";

describe("Google", () => {
  describe("GoogleRMKT", () => {
    let context = {};
    beforeEach(() => {
      jest.spyOn(GoogleRMKT, "enable");
      jest.spyOn(GoogleRMKT, "wait");
      jest.spyOn(GoogleRMKT, "init");
      jest.spyOn(GoogleRMKT, "paso1");
      jest.spyOn(GoogleRMKT, "paso2");
      jest.spyOn(GoogleRMKT, "paso3");
      jest.spyOn(GoogleRMKT, "paso4");
      jest.spyOn(GoogleRMKT, "gracias");
      jest.spyOn(GoogleRMKT, "mensaje");

      window.google_trackConversion = jest.fn();
      window.google_tag_params = {};

      document.createElement = jest.fn();
      document.getElementsByTagName = jest.fn(() => [
        {
          appendChild: jest.fn(),
          parentNode: {
            insertBefore: jest.fn()
          }
        }
      ]);

      window.gtag = jest.fn();
    });

    it("configuracion exportada por defecto", () => {
      expect(GoogleRMKT).toBeDefined();
      expect(GoogleRMKT).not.toBeNull();
    });

    it("configuracion por defecto para init", () => {
      GoogleRMKT.init();
      const initMock = jest.spyOn(GoogleRMKT, "init");
      expect(initMock).toHaveBeenCalledTimes(1);
    });

    it("configuracion por defecto para paso1", () => {
      GoogleRMKT.paso1();
      const paso1Mock = jest.spyOn(GoogleRMKT, "paso1");
      expect(paso1Mock).toHaveBeenCalledTimes(1);
    });

    it("configuracion por defecto para paso2", () => {
      GoogleRMKT.paso2();
      const paso2Mock = jest.spyOn(GoogleRMKT, "paso2");
      expect(paso2Mock).toHaveBeenCalledTimes(1);
    });

    it("configuracion por defecto para paso3", () => {
      GoogleRMKT.paso3();
      const paso3Mock = jest.spyOn(GoogleRMKT, "paso3");
      expect(paso3Mock).toHaveBeenCalledTimes(1);
    });

    it("configuracion por defecto para paso4", () => {
      GoogleRMKT.paso4();
      const paso4Mock = jest.spyOn(GoogleRMKT, "paso4");
      expect(paso4Mock).toHaveBeenCalledTimes(1);
    });

    it("configuracion por defecto para gracias", () => {
      GoogleRMKT.gracias();
      const graciasMock = jest.spyOn(GoogleRMKT, "gracias");
      expect(graciasMock).toHaveBeenCalledTimes(1);
    });

    it("configuracion por defecto para mensaje ERROR_TECNICO", () => {
      context = {
        mutation: {
          payload: {
            params: {
              mje: ERRORES.ERROR_TECNICO
            }
          }
        }
      };
      GoogleRMKT.mensaje(context);
      const mensajeMock = jest.spyOn(GoogleRMKT, "mensaje");
      expect(mensajeMock).toHaveBeenCalledTimes(1);
    });

    it("configuracion por defecto para mensaje INDIVIDUO_NEGATIVO", () => {
      context = {
        mutation: {
          payload: {
            params: {
              mje: ERRORES.INDIVIDUO_NEGATIVO
            }
          }
        }
      };
      GoogleRMKT.mensaje(context);
      const mensajeMock = jest.spyOn(GoogleRMKT, "mensaje");
      expect(mensajeMock).toHaveBeenCalledTimes(2);
    });
  });

  describe("GoogleSiteTag", () => {
    let context = {};
    beforeEach(() => {
      jest.spyOn(GoogleSiteTag, "enable");
      jest.spyOn(GoogleSiteTag, "wait");
      jest.spyOn(GoogleSiteTag, "landing");
      jest.spyOn(GoogleSiteTag, "paso1");
      jest.spyOn(GoogleSiteTag, "paso2");
      jest.spyOn(GoogleSiteTag, "paso3");
      jest.spyOn(GoogleSiteTag, "paso4");
      jest.spyOn(GoogleSiteTag, "gracias");
      jest.spyOn(GoogleSiteTag, "mensaje");

      window.google_tag_params = {};

      document.createElement = jest.fn();
      document.getElementsByTagName = jest.fn(() => [
        {
          appendChild: jest.fn(),
          parentNode: {
            insertBefore: jest.fn()
          }
        }
      ]);

      window.gtag = jest.fn();
    });

    it("configuracion exportada por defecto", () => {
      expect(GoogleSiteTag).toBeDefined();
      expect(GoogleSiteTag).not.toBeNull();
    });

    it("configuracion por defecto para paso1", () => {
      GoogleSiteTag.paso1();
      const paso1Mock = jest.spyOn(GoogleSiteTag, "paso1");
      expect(paso1Mock).toHaveBeenCalledTimes(1);
    });

    it("configuracion por defecto para paso2", () => {
      GoogleSiteTag.paso2();
      const paso2Mock = jest.spyOn(GoogleSiteTag, "paso2");
      expect(paso2Mock).toHaveBeenCalledTimes(1);
    });

    it("configuracion por defecto para paso3", () => {
      GoogleSiteTag.paso3();
      const paso3Mock = jest.spyOn(GoogleSiteTag, "paso3");
      expect(paso3Mock).toHaveBeenCalledTimes(1);
    });

    it("configuracion por defecto para paso4", () => {
      GoogleSiteTag.paso4();
      const paso4Mock = jest.spyOn(GoogleSiteTag, "paso4");
      expect(paso4Mock).toHaveBeenCalledTimes(1);
    });

    it("configuracion por defecto para gracias", () => {
      GoogleSiteTag.gracias();
      const graciasMock = jest.spyOn(GoogleSiteTag, "gracias");
      expect(graciasMock).toHaveBeenCalledTimes(1);
    });

    it("configuracion por defecto para landing", () => {
      GoogleSiteTag.landing();
      const landingMock = jest.spyOn(GoogleSiteTag, "landing");
      expect(landingMock).toHaveBeenCalledTimes(1);
    });

    it("configuracion por defecto para mensaje ERROR_TECNICO", () => {
      context = {
        mutation: {
          payload: {
            params: {
              mje: ERRORES.ERROR_TECNICO
            }
          }
        }
      };
      GoogleSiteTag.mensaje(context);
      const mensajeMock = jest.spyOn(GoogleSiteTag, "mensaje");
      expect(mensajeMock).toHaveBeenCalledTimes(1);
    });

    it("configuracion por defecto para mensaje INDIVIDUO_NEGATIVO", () => {
      context = {
        mutation: {
          payload: {
            params: {
              mje: ERRORES.INDIVIDUO_NEGATIVO
            }
          }
        }
      };
      GoogleSiteTag.mensaje(context);
      const mensajeMock = jest.spyOn(GoogleSiteTag, "mensaje");
      expect(mensajeMock).toHaveBeenCalledTimes(2);
    });
  });
});
